import { FmSkeleton } from "@/ui-component";
import styles from "./productInTable.module.scss";

export default function ProductInTableSkeleton() {
    return (
        <>
            <ProductSkeleton />
            <ProductSkeleton />
            <ProductSkeleton />
            <ProductSkeleton />
        </>
    );
}

function ProductSkeleton() {
    return (
        <div className={styles["like-product-item"]}>
            <FmSkeleton
                variant="rounded"
                style={{
                    marginBottom: "0.2rem",
                }}
                height={"1.54rem"}
            />
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    height: "0.3rem",
                }}
            >
                <div style={{ display: "flex" }}>
                    <FmSkeleton
                        variant="rounded"
                        width={"1rem"}
                        style={{ margin: "0 0.1rem 0 0" }}
                    />
                    <FmSkeleton
                        variant="rounded"
                        style={{ margin: "0 0.1rem 0 0" }}
                        width={"0.3rem"}
                    />
                </div>
                <FmSkeleton variant="rounded" width={"1.4rem"} />
            </div>
        </div>
    );
}
